document.addEventListener("DOMContentLoaded", () => {
    function playMusicAndShowImage(musicId, imageId, active) {
        const music = document.getElementById(musicId);
        const image = document.getElementById(imageId);

        if (active) {
            if (music.readyState >= 2) { // Ensure the audio is ready to play
                music.play().catch(error => console.error('Error attempting to play:', error));
            }
            image.style.display = "block";
        } else {
            music.pause();
            music.currentTime = 0;
            image.style.display = "none";
        }
    }

    function updateButtonStyles(activeButtonId, inactiveButtonId) {
        const activeButton = document.getElementById(activeButtonId);
        const inactiveButton = document.getElementById(inactiveButtonId);

        activeButton.style.backgroundColor = "green";
        inactiveButton.style.backgroundColor = "black";
    }

    // Initialize the state
    document.getElementById("primaryWrapper").style.display = "block"; // Show the ANC On GIF by default
    updateButtonStyles("primaryBtn", "secondaryBtn");

    const primaryBtn = document.getElementById("primaryBtn");
    const secondaryBtn = document.getElementById("secondaryBtn");

    primaryBtn.addEventListener("click", () => {
        playMusicAndShowImage("primaryMusic", "primaryWrapper", true);
        playMusicAndShowImage("secondaryMusic", "secondaryWrapper", false);
        updateButtonStyles("primaryBtn", "secondaryBtn");
    });

    secondaryBtn.addEventListener("click", () => {
        playMusicAndShowImage("secondaryMusic", "secondaryWrapper", true);
        playMusicAndShowImage("primaryMusic", "primaryWrapper", false);
        updateButtonStyles("secondaryBtn", "primaryBtn");
    });

    // Ensure user interaction is captured to play audio
    document.body.addEventListener('touchstart', () => {
        const primaryMusic = document.getElementById('primaryMusic');
        const secondaryMusic = document.getElementById('secondaryMusic');

        primaryMusic.play().catch(() => {});
        primaryMusic.pause();

        secondaryMusic.play().catch(() => {});
        secondaryMusic.pause();
    }, { once: true });
});